export default [
  { value: '0', image: '/images/zero.jpg', tintColor: 'rgba(0,0,0,0.05)', color: 'rgb(134, 168, 178)' },
  { value: '0.5', image: '/images/half.jpg', color: 'rgba(255,255,255,0.6)' },
  { value: '1', image: '/images/one.jpg', color: 'rgba(255,255,255,0.6)', tintColor: 'rgba(0,0,0,0.2)' },
  { value: '2', image: '/images/two.jpg', hideValue: true, tintColor: 'rgba(0,0,0,0)' },
  { value: '3', image: '/images/three.jpg', hideValue: true, tintColor: 'rgba(0,0,0,0.35)', color: 'rgba(255,255,255,0.5)' },
  { value: '5', image: '/images/five.jpg', tintColor: 'rgba(255,255,255,0.35)', color: 'rgba(0,0,0,0.75)' },
  { value: '8', image: '/images/eight.jpg', color: 'rgba(255,255,255,0.5)' },
  { value: '13', image: '/images/thirteen.jpg', hideValue: true, tintColor: 'rgba(0,0,0,0.05)', color: 'rgba(155, 255, 55, 0.6)' },
  { value: '20', image: '/images/twenty.jpg', hideValue: true, tintColor: 'rgba(0,0,0,0.15)', color: 'rgb(49, 39, 94)' },
  { value: '40', image: '/images/fourty.jpg', hideValue: true, tintColor: 'rgba(0,0,0,0.05)', color: 'rgb(159, 39, 60)' },
  { value: '100', image: '/images/hundreed.jpg', tintColor: 'rgba(0,0,0,0.5)', color: 'rgb(200, 200, 200)' },
  { value: '?', image: '/images/question.jpg', color: 'white', tintColor: 'rgba(255,0,0,0.5)' },
  { value: '☕️', image: '/images/coffee.jpg', hideValue: true, tintColor: 'rgba(0,0,0,0)' },
]

/* Images credits
  0 Photo by Sarah Louise Kinsella on Unsplash
  0.5 Photo by Pietro De Grandi on Unsplash
  1 Photo by Jon Sailer on Unsplash
  2 Photo by Max Ostrozhinskiy on Unsplash
  3 Photo by Florencia Viadana on Unsplash
  5 Photo by rawpixel on Unsplash
  8 Photo by Lee Agosila on Unsplash
  13 Photo by Franck V. on Unsplash
  20 Photo by Chris Moore on Unsplash
  40 Photo by Ksenia Kudelkina on Unsplash
  100 Photo by Obi Onyeador on Unsplash
  Question Photo by Luke Stackpoole on Unsplash
  Coffee Photo by Nathan Dumlao on Unsplash
*/
